import { Leaf } from "lucide-react";

const ITEMS = [
    "Air Source Heat Pumps",
    "Serving England & Wales",
    "Up to £7,500 Boiler Upgrade Scheme Grant",
    "Property-Specific System Design",
    "Clean Energy for a Brighter Tomorrow",
];

export const Marquee = () => (
    <div className="overflow-hidden border-y border-slate-200 bg-white py-5" aria-hidden="true">
        <div className="animate-marquee flex w-max items-center gap-12">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span
                    key={i}
                    className="flex items-center gap-12 whitespace-nowrap font-display text-xs font-semibold uppercase tracking-[0.35em] text-slate-400"
                >
                    {item}
                    <Leaf className="h-4 w-4 text-emerald-600" />
                </span>
            ))}
        </div>
    </div>
);
